import React, { useEffect, useState, useCallback } from 'react'
import './ClientRepresentative.css'
import PortalHeader from '../clientNavbar/PortalHeader'

// Assets
import kylePic from '../client-dashboard-assets/kyle.jpg'

const ClientRepresentative = () => {

    // Ensure the page always start at the top
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);

    // Particles Background
    // const particlesInit = useCallback(async (main: Engine) => {
    //     await loadFull(main);
    //     await loadPolygonMaskPlugin(main);
    // }, []);

    // const [width, setWidth] = useState<number>(window.innerWidth);
    // const [height, setHeight] = useState(document.documentElement.scrollHeight);

    // const [heightTopParticles, setHeightTopParticles] = useState<number>(window.innerHeight);

    return (
        <div className='representative-wrapper'>

            <PortalHeader />

            <h1 className='representative-h1'><strong> Your FNN Representative</strong></h1>

            <div className='rep-pic-and-info'>

                <div className='rep-image-div'>
                    <img className="rep-pic" alt={`${kylePic} headshot`} src={kylePic} />
                </div>



                <div className='rep-name'>

                    <div>
                        <h1><strong>Kyle Miller</strong> </h1>
                        <h2>Chief Revenue Officer</h2>
                        <h3><strong>About Me</strong> </h3>
                        <p>
                            Kyle Miller is FNN’s Chief Revenue Officer and your primary point of contact
                            for all inquiries. Accomplished business executive with a successful track record
                            spanning venture-backed entrepreneurial organizations to major multinational companies.
                            A strategic thinker with a high level of emotional intelligence, humility, and focus.
                            A leadership team member with turnaround experience and a deep understanding of how to
                            move the needle through improvements in quality, efficiency, and productivity.
                        </p>
                    </div>

                    <div>
                        <h4><strong>Contact</strong> </h4>

                        <div className='rep-contact'>
                            <div className='mini-rep-contact'>
                                <p><strong>Email</strong></p>
                                team@fireneuralnetwork.com
                            </div>

                            <div className='mini-rep-contact'>
                                <p><strong>Office Hours</strong></p>
                                Monday - Friday, 8:00 AM - 5:00 PM EST <br/>
                                Available 24/7 via mobile for client support
                            </div>

                        </div>

                        <div className='mini-rep-contact'>
                            <p><strong>Phone Number</strong></p>
                            +1 (954)-681-1770
                        </div>

                        {/* <h4><strong>Additional Contact</strong> </h4>

                        <div className='mini-rep-contact'>
                            <p><strong>Email</strong></p>
                            <p>info@fireneuralnetwork.com</p>
                        </div> */}
                    </div>

                </div>

            </div>

        </div>
    )
}

export default ClientRepresentative